import { Company, BuildingPosition } from '../../types/career';
import Building from './Building';

interface BuildingRowProps {
  companies: Company[];
  positions: BuildingPosition[];
  side: 'top' | 'bottom';
  nearbyBuildingId: string | null;
  onBuildingClick: (id: string) => void;
}

const BuildingRow = ({
  companies,
  positions,
  side,
  nearbyBuildingId,
  onBuildingClick,
}: BuildingRowProps) => {
  const filteredCompanies = companies.filter(c => c.side === side);

  return (
    <div
      className={`relative flex items-${side === 'top' ? 'end' : 'start'}`}
      style={{
        height: '220px',
        paddingBottom: side === 'top' ? '0' : '0',
        paddingTop: side === 'bottom' ? '0' : '0',
      }}
    >
      {filteredCompanies.map(company => {
        const position = positions.find(p => p.id === company.id);
        if (!position) return null;

        return (
          <div
            key={company.id}
            className="absolute"
            style={{
              left: `${position.x}px`,
              bottom: side === 'top' ? 0 : undefined,
              top: side === 'bottom' ? 0 : undefined,
            }}
          >
            <Building
              company={company}
              isNearby={nearbyBuildingId === company.id}
              onClick={() => onBuildingClick(company.id)}
              side={side}
            />
          </div>
        );
      })}
    </div>
  );
};

export default BuildingRow;
